module.exports = __webpack_public_path__ + "img/faceShield.f461f332.png";